import React from 'react'
import { useTransition, animated, config } from 'react-spring'

import { ReactComponent as CheckIconSVG } from '../assets/icon-check.svg'
import { ReactComponent as XIconSVG } from '../assets/icon-x.svg'

import { Box, SVG, Flex, Text } from 'system'

const getTheme = type => {
  switch (type) {
    case 'success':
      return {
        bg: 'green.50',
        svg: CheckIconSVG,
      }
    case 'error':
      return {
        bg: 'red.50',
        svg: XIconSVG,
      }
    default:
      return {
        bg: 'green.50',
        svg: CheckIconSVG,
      }
  }
}

export const DocsToast = React.memo(
  ({ heading, children, type = 'success', trigger }) => {
    const transitions = useTransition(trigger, null, {
      from: { opacity: 0, transform: 'translate3d(0, 100%, 0)' },
      enter: { opacity: 1, transform: 'translate3d(0, 0%, 0)' },
      leave: { opacity: 0, transform: 'translate3d(0, 100%, 0)' },
      config: config.wobbly,
    })
    const theme = React.useMemo(() => getTheme(type), [type])

    return transitions.map(
      ({ item, props }) =>
        item && (
          <Flex
            as={animated.div}
            bg="white"
            boxShadow="0 3px 6px hsla(0, 0%, 0%, .15), 0 2px 4px hsla(0, 0%, 0%, .12)"
            position="absolute"
            bottom={20}
            borderRadius="4px"
            maxWidth="25rem"
            style={props}
            mx="auto"
          >
            <Flex
              bg={theme.bg}
              px={3}
              justifyContent="center"
              alignItems="center"
              borderRadius="4px 0 0 4px"
            >
              <SVG x={1} y={1} svg={theme.svg} width="2rem" fill="white" />
            </Flex>
            <Box px={2} py={1}>
              {heading && (
                <Text
                  color="gray.30"
                  fontWeight="bold"
                  lineHeight="copy"
                  fontSize="midMedium"
                >
                  {heading}
                </Text>
              )}
              <Text color="gray.30" lineHeight="copy">
                {children}
              </Text>
            </Box>
          </Flex>
        ),
    )
  },
)

export default DocsToast
